import { render, staticRenderFns } from "./FormAgreement.vue?vue&type=template&id=27cb4252&scoped=true&"
import script from "./FormAgreement.vue?vue&type=script&lang=ts&"
export * from "./FormAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb4252",
  null
  
)

export default component.exports